import { useAtomValue } from 'jotai'

import { SequenceMenu } from '@sequencehq/core-components'

import {
  invoiceCurrencyAtom,
  invoiceCustomerBillingAddressAtom
} from 'Invoices/atoms/invoiceEditing.atom'
import { InvoiceMerchantDetailsModal } from 'Invoices/components'

export const MenuItemViewPaymentDetails = () => {
  const currency = useAtomValue(invoiceCurrencyAtom)
  const customerBillingAddress = useAtomValue(invoiceCustomerBillingAddressAtom)

  if (!currency || !customerBillingAddress) return null

  return (
    <InvoiceMerchantDetailsModal
      trigger={
        <SequenceMenu.Item
          uuid="view-payment-details"
          label="View payment details"
          data-testid="header.kebab-menu.view-payment-details"
        />
      }
      currency={currency}
      country={customerBillingAddress.country}
    />
  )
}
